'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('modules/settings/templates/partials/subscription/empty.hbs');

var SubscriptionEmptyView = ItemView.extend({
    template: template,

    className: 'container subscription-empty',

    ui: {
        // updatePaymentMethod:    '[data-action="update-payment-method"]',
    },

    events: {
        // 'click @ui.updatePaymentMethod':    'updatePaymentMethod',
    },
});

module.exports = SubscriptionEmptyView;